import { BankOutlined, FileTextOutlined, UserOutlined, ArrowUpOutlined } from '@ant-design/icons';

interface UniversitySurveysCardProps {
  selectedTopic: string;
  totalUsers?: number;
  totalStudents?: number;
  participatedUniversitiesCount?: number;
  totalUniversitiesCount?: number;
}

const UniversitySurveysCard = ({ 
  selectedTopic, 
  totalUsers = 0,
  totalStudents = 0,
  participatedUniversitiesCount = 0,
  totalUniversitiesCount = 0
}: UniversitySurveysCardProps) => {
  // Dinamik ma'lumotlardan foydalanish
  const participatedUsers = totalUsers;
  const allStudents = totalStudents;

  return (
    <div className="stat-card-compact combined-card">
      {/* Universitetlar ishtiroki section */}
      <div className="combined-card-section">
        <div className="stat-card-header">
          <div className="stat-icon purple">
            <BankOutlined />
          </div>
        </div>
        <div className="stat-title">Ishtirok etgan universitetlar</div>
        <div className="stat-subtitle">{222} ta universitetdan {participatedUniversitiesCount} tasi ishtirok etdi</div>
        <div className="stat-content">
          <h2 className="stat-number">{participatedUniversitiesCount}</h2>
          <span className="stat-badge positive">
            <ArrowUpOutlined /> {totalUniversitiesCount > 0 ? ((participatedUniversitiesCount / totalUniversitiesCount) * 100).toFixed(1) : 0}%
          </span>
        </div>
      </div>

      {/* Divider */}
      <div className="combined-card-divider"></div>

      {/* So'rovnomalar section */}
      <div className="combined-card-section">
        <div className="stat-card-header">
          <div className="stat-icon purple">
            <FileTextOutlined />
          </div>
        </div>
        <div className="stat-title">So'rovnomalar</div>
        <div className="stat-subtitle">Faol so'rovnomalar</div>
        <div className="stat-content">
          <h2 className="stat-number">{selectedTopic ? 1 : 0}</h2>
          <span className="stat-badge positive">
            <ArrowUpOutlined /> {selectedTopic ? 'Tanlangan' : 'Tanlanmagan'}
          </span>
        </div>
      </div>
      {/* Divider */}
      <div className="combined-card-divider"></div>

      {/* Jami Foydalanuvchilar section */}
      <div className="combined-card-section">
        <div className="stat-card-header">
          <div className="stat-icon purple">
            <UserOutlined />
          </div>
        </div>
        <div className="stat-title">Jami foydalanuvchilar</div>
        <div className="stat-subtitle">Ishtirok etganlar: {participatedUsers.toLocaleString()}</div>
        <div className="stat-content">
          <h2 className="stat-number">{allStudents.toLocaleString()}</h2>
          <span className="stat-badge positive">
            <ArrowUpOutlined /> {allStudents > 0 ? ((participatedUsers / allStudents) * 100).toFixed(1) : 0}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default UniversitySurveysCard;
